<div class="salesforce-field" [formGroup]="form">
  <div [ngSwitch]="true">

    <div *ngSwitchCase="field.type === salesforceFieldTypes.STRING ||
                        field.type === salesforceFieldTypes.TEXTAREA ||
                        field.type === salesforceFieldTypes.EMAIL ||
                        field.type === salesforceFieldTypes.PHONE ||
                        field.type === salesforceFieldTypes.ENCRYPTEDSTRING ||
                        field.type === salesforceFieldTypes.URL"
         class="form-row mat-row">
      <mat-form-field floatLabel="always">
        <input matInput [formControlName]="field.name" placeholder="{{ field.label }}">
      </mat-form-field>
      <mat-error class="error-message mat-error-message" *ngIf="!isValid">
        {{ "salesforceField.required" | translate: { label: field.label } }}
      </mat-error>
      <mat-error class="error-message mat-error-message" *ngIf="errorText">
        {{ errorText }}
      </mat-error>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.DATE ||
                        field.type === salesforceFieldTypes.DATETIME ||
                        field.type === salesforceFieldTypes.TIME"
         class="form-row mat-row">
      <mat-form-field floatLabel="always">
        <mat-label>{{ field.label }}</mat-label>
        <input matInput [formControlName]="field.name" [placeholder]="getPlaceholder()" [textMask]="{ mask: getMask() }">
      </mat-form-field>
      <div *ngIf="!isValid">
        <mat-error class="error-message mat-error-message" *ngIf="form.controls[field.name].errors.required">
          {{ "salesforceField.required" | translate: { label: field.label } }}
        </mat-error>
        <mat-error class="error-message mat-error-message" *ngIf="form.controls[field.name].errors.pattern">
          {{ "salesforceField.patternError" | translate: { label: field.label } }}
        </mat-error>
      </div>
      <mat-error class="error-message mat-error-message" *ngIf="errorText">
        {{ errorText }}
      </mat-error>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.PERCENT" class="form-row mat-row">
      <div class="percentage-input-container">
        <mat-form-field floatLabel="always">
          <input matInput [formControlName]="field.name"
                 placeholder="{{ field.label }}"
                 type="number" min="0" max="100" step="1">
          <div matSuffix>%</div>
        </mat-form-field>
        <mat-error class="error-message mat-error-message" *ngIf="!isValid">
          {{ "salesforceField.required" | translate: { label: field.label } }}
        </mat-error>
        <mat-error class="error-message mat-error-message" *ngIf="errorText">
          {{ errorText }}
        </mat-error>
      </div>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.INTEGER ||
                        field.type === salesforceFieldTypes.DOUBLE ||
                        field.type === salesforceFieldTypes.CURRENCY"
         class="form-row mat-row">
      <mat-form-field floatLabel="always" class="integer-field">
        <input matInput [formControlName]="field.name"
               placeholder="{{ field.label }}"
               type="number">
      </mat-form-field>
      <mat-error class="error-message mat-error-message" *ngIf="!isValid">
        {{ "salesforceField.required" | translate: { label: field.label } }}
      </mat-error>
      <mat-error class="error-message mat-error-message" *ngIf="errorText">
        {{ errorText }}
      </mat-error>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.PICKLIST" class="form-row mat-row">
      <mat-form-field floatLabel="always">
        <mat-label>{{ field.label }}</mat-label>
        <mat-select [formControlName]="field.name"
                    [(ngModel)]="field.value"
                    placeholder="{{ 'salesforceField.pickListPlaceholder' | translate }}">
          <mat-option *ngFor="let item of field.controlledPicklistValues" [value]="item.value">{{ item.label }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error class="error-message mat-error-message" *ngIf="isEnabled && !isValid">
        {{ "salesforceField.required" | translate: { label: field.label } }}
      </mat-error>
      <mat-error class="error-message mat-error-message" *ngIf="errorText">
        {{ errorText }}
      </mat-error>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.MULTIPICKLIST" class="form-row mat-row">
      <app-salesforce-multipicklist-field [field]="field" [form]="form" [errorText]="errorText"></app-salesforce-multipicklist-field>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.BOOLEAN" class="form-row checkbox-row">
      <mat-checkbox [formControlName]="field.name" [disableRipple]="true">{{ field.label }}</mat-checkbox>
    </div>

    <div *ngSwitchCase="field.type === salesforceFieldTypes.REFERENCE" class="form-row">
      <app-salesforce-reference-field
        [chatId]="chatId"
        [field]="field"
        [form]="form"
        [context]="context"
        [errorText]="errorText"></app-salesforce-reference-field>
    </div>
  </div>
</div>
